export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_felipe_baranska.png",
      alt: "Nome da extensão",
    },
    title: "Opere com Baranska Winfut",
    text: [
      "Diante de muitos anos gravando tela para extrair os melhores números que possam resultar no preço do ativo e tomar a melhor decisão possível de compra ou venda,  \n\nfinalmente conseguimos criar uma equação onde mostra uma possível direção do mercado.",
      "Esses números são camaleão, se adaptam ao mercado conforme sua dinâmica. \n\nAo automatizar essa decisão, e jamais depender de operações manuais e principalmente depender do fator psicológico que afetam a maioria dos Traders a performar, estamos disponibilizando esse robô aos clientes.",
    ],
    testimonial: {
      text: "Adaptabilidade, Resiliência e inovação são nossas essências.",
      author: {
        name: "Felipe Baranska Furtado, Head de Estratégias, Baranska Winfut ",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  stats: {
    title: "Alguns números do Baranska Winfut",
    subtitle: "Experiência de anos que inauguro na Ontick",
    data: [
      {
        value: "+1",
        description: "Ano em atividade",
      },
      {
        value: "+50",
        description: "Clientes satisfeitos",
      },
      {
        value: "+1k",
        description: "de Ordens executadas por ano",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Felipe Baranska Investimentos?",
    subtitle: "Veja quais as principais vantagens dos robôs da Felipe Baranska Investimentos.",
    data: [
      {
        title: "Vantagem 01",
        description: "7 dias Para testar.",
      },
      {
        title: "Vantagem 02",
        description: "100% automatizados.",
      },
      {
        title: "Vantagem 03",
        description: "Suporte individual.",
      },
      {
        title: "Vantagem 04",
        description: "Velocidade.",
      },
      {
        title: "Vantagem 05",
        description: "Ganhe tempo.",
      },
      {
        title: "Vantagem 06",
        description: "Sem emocional.",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão Baranska Winfut.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Felipe Baranska Investimentos",
    col1: [
      " Há mais de 8 anos em frente da tela, Felipe Baranska Furtado se especializou em mercado futuro, buscando o melhor risco x retorno baseado em análise quantitativa. ",
      "Nossa missão é transformar informações em números precisos para tomada de decisão automatizadas com algoritmos.",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Felipe Baranska Investimentos",
  },
  strategies: {
    title: "Estratégia Baranska Winfut",
    heading: "Algoritmos Quantitativos à sua disposição.",
    subtitle:
      "Com adaptabilidade, resiliência e inovação, nossas estratégias prontas, desenvolvidas por profissionais, levam você ao sucesso com apenas alguns cliques.",
  },
  testimonials: [
    {
      text: 'Eu era novo na trading e sempre hesitava por medo de errar. O robô mudou tudo: é frio, calcula tudo com precisão e se adapta ao mercado. Em três meses, meu retorno foi 15% maior que o esperado, com risco controlado. Nunca mais decido na emoção!" ',
      author: "Isaias Medeiros",
      job: "Comerciante",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Depois de anos operando manualmente, o psicológico sempre atrapalhava. Após contratar o robô, percebi que apareceram resultados positivos, sem hesitação, minha taxa de acerto subiu.",
      author: "Flávio Leite",
      job: "Farmacêutico",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
